var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingComponent"},[_c('custom-loading-component',{attrs:{"active":_vm.isLoadingFromAPI,"can-cancel":false,"is-full-page":true,"color":"#33304c"},on:{"update:active":function($event){_vm.isLoadingFromAPI=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }